import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { CategoryProductsService } from '@shared/service/homepage-data/category-products.service';
import { ProductsShowcaseComponent } from '../../../shared/components/products-showcase/products-showcase.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-our-products',
    templateUrl: './our-products.component.html',
    styleUrls: ['./our-products.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProductsShowcaseComponent, AsyncPipe],
})
export class OurProductsComponent implements OnInit {
    private categoryProductsService = inject(CategoryProductsService);

    category$ = this.categoryProductsService.category$;
    products$ = this.categoryProductsService.productsByCategory$;

    ngOnInit(): void {
        this.categoryProductsService.dispatch();
    }
}
